<template>
  <checkable-button
    v-model="isChecked"
    class="custom-checkbox"
    :class="{
      'custom-checkbox-checked': isChecked
    }"
  >
    <div class="custom-checkbox-control">
      <md-icon
        md-src="/static/images/icon-checkbox.svg"
        class="custom-checkbox-control-icon"
      />
    </div>

    <div
      v-if="label"
      class="custom-checkbox-label"
    >
      {{ label }}
    </div>
  </checkable-button>
</template>

<script>
import CheckableButton from '@/components/common/CheckableButton'

export default {
  name: 'Checkbox',
  components: {
    CheckableButton
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isChecked: this.value
    }
  },
  watch: {
    value(newValue) {
      if (newValue !== this.isChecked) {
        this.isChecked = newValue
      }
    },
    isChecked(newValue) {
      if (newValue !== this.value) {
        this.$emit('input', newValue)
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@use '@/../static/stylesheets/variables' as *;

.custom-checkbox {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;

  &-control {
    width: 1rem;
    height: 1rem;
    border-radius: 0.25rem;
    border: 2px solid #E6E6E6;
    position: relative;
    transition: all 0.2s ease-in-out;

    &-icon {
      color: #ffffff;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%) scale(0);
      width: 1rem;
      height: 1rem;
      min-width: auto;
      min-height: auto;
      transition: transform 0.1s ease-in-out;
    }
  }

  &-checked &-control {
    background-color: $brand-primary;
    border-color: $brand-primary;
  }

  &-checked &-control-icon {
    transform: translate(-50%, -50%) scale(1);
  }

  &-label {
    font-size: 0.875rem;
    font-weight: 500;
    color: #363636;
  }
}
</style>
